import { ColumnConfig } from '../hooks/useTablePreferences';

export const wellnessCategoryColumns: ColumnConfig[] = [
  { key: 'title', label: 'Title', defaultWidth: 120, minWidth: 80, visible: true, sortable: true, resizable: true },
  { key: 'subtitle', label: 'Subtitle', defaultWidth: 130, minWidth: 80, visible: true, sortable: true, resizable: true },
  { key: 'wellnessItem', label: 'Wellness Item', defaultWidth: 120, minWidth: 80, visible: true, sortable: true, resizable: true },
];
